import { Eye } from "lucide-react";
import { useLingui } from "@lingui/react/macro";
import { Button } from "@/components/ui/button";

interface PreviewModeBannerProps {
  onExit: () => void;
}

export function PreviewModeBanner({ onExit }: PreviewModeBannerProps) {
  const { t } = useLingui();

  return (
    <div className="fixed bottom-5 left-1/2 z-50 flex h-13 -translate-x-1/2 items-center gap-2 overflow-hidden rounded-[10px] bg-(--color-action) px-4 shadow-[0px_24px_48px_-12px_rgba(16,24,40,0.18)]">
      <div className="flex items-center gap-2">
        <Eye className="size-5 shrink-0 text-white/80" />
        <p className="whitespace-nowrap text-base text-white/80">
          <span className="font-medium">{t`You're in preview mode:`}</span>
          <span className="font-normal">{t` This is how the recipe will appear when published.`}</span>
        </p>
      </div>
      <div className="mx-1 h-6 w-px shrink-0 bg-white/20" />
      <Button
        variant="ghost"
        type="button"
        onClick={onExit}
        className="shrink-0 whitespace-nowrap text-base font-medium text-white transition-colors hover:text-white/80 hover:bg-transparent"
      >
        {t`Exit preview`}
      </Button>
    </div>
  );
}
